import type { Dispatch, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { compose } from 'redux';

export interface IInterceptorMiddleware {
    all: () => Middleware[];
    add: (mw: Middleware) => void;
    remove: (mw: Middleware) => void;
    middleware: () => Middleware;
}

const builderInterceptorMiddleware = (): IInterceptorMiddleware => {
    const middlewares: Middleware[] = [];

    const interceptorMiddleware: Middleware =
        ({ getState, dispatch }: MiddlewareAPI) =>
        (next: Dispatch) =>
        (action: MiddlewareAPI) => {
            const middlewareAPI: MiddlewareAPI = {
                getState,
                dispatch,
            };

            const chain = middlewares.map(middleware => middleware(middlewareAPI));

            compose<(action: MiddlewareAPI) => void>(...chain)(next)(action);
        };

    const middleware: IInterceptorMiddleware = {
        all: () => middlewares,
        add: (mw: Middleware) => middlewares.push(mw),
        remove: (mw: Middleware) => {
            const index = middlewares.indexOf(mw);
            if (index >= 0) {
                middlewares.splice(index);
            }
        },
        middleware: () => interceptorMiddleware,
    };

    return middleware;
};

export default builderInterceptorMiddleware;
